export default [
    {
        name: 'id',
        formItem: {
            type: 'hidden'
        }
    },
    {
        title: '共建类型',
        name: 'type',
        dict: [
          { code: 1, codeName: '经销商' },
          { code: 2, codeName: '服务商' },
          { code: 99, codeName: '暂定' },
          { code: 0, codeName: '无' }
        ],
        tableItem: {}
    },
    {
      title: '经销商简称',
      name: 'shortName',
      tableItem: { }
    },
    {
      title: '销售代码',
      name: 'preSalesNumber',
      tableItem: {}
    },
    {
      title: '售后代码',
      name: 'afterSalesNumber',
      tableItem: {}
    },
    {
      title: '品牌',
      name: 'brandName',
      tableItem: {}
    },
    {
      title: '区域',
      name: 'areaName',
      tableItem: {}
    },
    {
        title: '开店状态',
        name: 'state',
        dict: [
          { code: 0, codeName: '已关店' },
          { code: 1, codeName: '已开店' },
          { code: 2, codeName: '建设中' }
        ],
        tableItem: {}
    }
]
